<template>
    <div class="public_container personnel_invite_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <ul class="tab_wrap" v-if="type != 1">
            <li
                v-for="item in inviteTypeList"
                :class="{ active: inviteType === item.type }"
                @click="handleClickTab(item.type)"
            >
                <span>{{ item.title }}</span>
            </li>
        </ul>
        <div class="mobile_container">
            <div class="qrcode_out_box" id="qrcodeOutBox" ref="qrcodeOutBox">
                <div id="qrcode" ref="qrcode"></div>
                <div class="invite_link">
                    <template v-if="inviteType == 1">
                        邀请你加入【{{ company_name }}】，区号为 +86 的手机号可通过链接加入
                    </template>
                    <template v-else> 【{{ user_name }}】邀请你加入<br />澜精灵ERP开启协同办公 </template>
                </div>
                <div class="invite_time">
                    <p>
                        失效时间：<span v-if="formattedDate">{{ formattedDate }}</span>
                    </p>
                    <p class="invalid_txt" @click="handleClickInvalid">
                        <i class="iconfont icon-tingyong"></i>立即失效
                    </p>
                </div>
            </div>
            <div class="down_btns">
                <van-button type="default" @click="handleClickCopyUrl">复制链接</van-button>
                <van-button type="info" @click="handleClickCopyImg">下载二维码</van-button>
            </div>
        </div>
        <van-dialog
            v-model="invalidVisible"
            title=""
            show-cancel-button
            confirmButtonColor="#2990FF"
            @confirm="handleInvalidConfirm"
            class="my_dialog my_invalid_dialog"
        >
            <p class="title">确定<span class="text_red">失效</span></p>
            <p>已分享的链接和二维码都将立即失效</p>
        </van-dialog>
    </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import { mapState } from "vuex";
import { encryptAES } from "@/utils/index";
import { addInviteLink, deleteInviteLink } from "@/api/index.js";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "MPersonnelInvite",
    components: { ReturnNavBar },
    data() {
        return {
            loading: false,
            type: 1, // 默认进来是1的话不显示切换栏
            inviteType: 1,
            inviteTypeList: [
                { type: 1, title: "邀请新员工" },
                { type: 2, title: "添加企业成员" },
            ],
            company_name: "",
            company_log: "",
            company_id: "",
            user_name: "",
            copyLink: "",
            formattedDate: "",
            QRCode: null,
            invalidVisible: false,
            invite_id: "",
        };
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created() {
        if (this.userInfo) {
            this.company_id = this.userInfo.user.company_id;
            this.company_name = this.userInfo.user.company_name;
            this.company_logo = this.userInfo.user.company_logo;
            this.user_name = this.userInfo.user.name;
        }
        if (this.$route.query) {
            const type = this.$route.query.type;
            this.type = type;
            this.inviteType = type;
            this.get_invite_link(type || 1);
        }
    },
    methods: {
        handleClickTab(tab) {
            this.inviteType = tab;
            this.get_invite_link(tab);
        },
        get_invite_link(tab) {
            let postData = {
                type: tab == 1 ? "person" : "enterprise",
            };
            this.loading = true;
            addInviteLink(postData)
                .then((res) => {
                    if (res.code === 200) {
                        let { invite_id, expiration_date } = res.data;
                        this.invite_id = invite_id;
                        this.formattedDate = expiration_date;
                        const domain = window.location.protocol + "//" + window.location.host;
                        this.copyLink = `${domain}/#/login/invit?type=${tab}&invite_id=${encryptAES(invite_id)}`;
                        this.setQrcode();
                    }
                    this.loading = false;
                })
                .catch(() => {});
        },
        setQrcode() {
            if (this.$refs.qrcode) {
                this.$refs.qrcode.innerHTML = "";
                setTimeout(() => {
                    this.QRCode = new QRCode(this.$refs.qrcode, {
                        width: 150,
                        height: 160,
                        render: "canvas",
                        fill: "#666666",
                        text: this.copyLink,
                        id: "canvasID",
                        correctLevel: 1,
                    });
                });
                this.$forceUpdate();
            }
        },
        handleClickCopyUrl() {
            let textToCopy = this.copyLink;
            if(this.inviteType == 1) {
                // 新员工加入
                textToCopy = `【${this.user_name}】邀请你加入【${this.company_name}】，请使用区号为 +86 的手机号通过此链接 ${this.copyLink} 加入`
            } else {
                // 添加企业成员
                textToCopy = `【${this.user_name}】邀请你加入澜精灵ERP开始协同办公，请使用区号为 +86 的手机号可通过此链接 ${this.copyLink} 加入`
            }
            const textarea = document.createElement("textarea");
            textarea.value = textToCopy;
            document.body.appendChild(textarea);
            // 选中文本并复制
            textarea.select();
            document.execCommand("copy");
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$toast("复制成功");
        },
        async handleClickCopyImg() {
            const canvas = await html2canvas(document.querySelector("#qrcodeOutBox"), {
                allowTaint: true,
                useCORS: true,
            });
            if (canvas) {
                const url = canvas.toDataURL("image/png").replace(/^data:image\/[^;]/, "data:application/octet-stream");
                var link = document.createElement("a");
                link.download = "邀请.png"; // 下载的文件名
                link.href = url;
                link.click();
                this.$toast("已保存到系统相册");
            }
        },
        handleClickInvalid() {
            this.invalidVisible = true;
        },
        handleInvalidConfirm() {
            deleteInviteLink({ invite_id: this.invite_id })
                .then((res) => {
                    if (res.code === 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.get_invite_link(this.inviteType);
                            },
                        });
                    }
                    this.loading = false;
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.personnel_invite_wrap {
    .tab_wrap {
        height: 44px;
        background-color: #ffffff;
        padding: 0 16px;
        display: flex;
        align-items: center;
        li {
            height: 100%;
            line-height: 44px;
            flex: 1;
            text-align: center;
            position: relative;
            span {
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                letter-spacing: 0px;
                color: rgba(0, 0, 0, 1);
            }

            &.active {
                &::after {
                    content: "";
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    height: 2px;
                    opacity: 1;
                    border-radius: 1px 1px, 0px, 0px;
                    background: #3997f2;
                }
            }
        }
    }
    .mobile_container {
        padding: 60px 16px 0;
    }
    .qrcode_out_box {
        border-radius: 8px;
        background: linear-gradient(180deg, #a1c4fd 0%, #c2e9fb 100%);
        background-image: url("https://download.hecoos.com/enlightv/2024-49/fb0f5490a0f3f3aa5147f23ba99fae6a.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
        padding: 40px 0 24px;
        text-align: center;
        #qrcode {
            margin: 0 auto;
            width: 150px;
            height: 160px;
            border-radius: 8px;
            background: #ffffff;
        }
        .invite_link {
            margin: 14px 0 12px;
            padding: 0 36px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            text-align: center;
        }
        .invite_time {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
            text-align: center;
        }
        .invalid_txt {
            width: fit-content;
            margin: 4px auto 0;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(228, 65, 68, 1);
            .iconfont {
                font-size: 12px;
                margin-right: 7px;
            }
        }
    }
    .down_btns {
        margin-top: 10px;
        display: flex;
        gap: 9px;
        .van-button {
            flex: 1;
            height: 38px;
            padding: 0;
            border-radius: 8px;
        }
        .van-button--default {
            border: 0;
            font-size: 16px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
        }
        .van-button--info {
            background-color: #2990ff;
            border-color: #2990ff;
            font-size: 16px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
        }
    }
}
.my_invalid_dialog {
    ::v-deep {
        .van-dialog__content {
            padding: 24px 0 !important;
            .title {
                font-size: 16px;
                font-weight: 700;
            }
            p {
                text-align: center;
                & + p {
                    margin-top: 16px;
                }
            }
        }
    }
}
</style>
